import { HeaderTitle, HeaderWrapper } from "./styled";
import loginActions from "../../redux/login/actions";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../../redux/reduxTypes";
import { GcoopSessionConfig } from "../../types/state.types";
import { useNavigate } from "react-router-dom";

type HeaderProps = {
  logged: boolean;
};

function Header({ logged }: HeaderProps) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const configsState = useSelector<StoreState, GcoopSessionConfig>(
    (state) => state.configsState
  );

  const handleLogout = () => {
    dispatch(loginActions.logout());
    navigate("/");
  };

  return (
    <HeaderWrapper>
      <HeaderTitle>
        <span>Área do Cooperado</span>
        {logged && <button onClick={handleLogout}>Sair</button>}
      </HeaderTitle>

      {/* <a target="_blank" href="http://coopernordestece.com.br/" rel="noreferrer"> */}
      <img
        src={"data:image/png;base64, " + configsState.Logo}
        alt={`Logotipo - ${configsState.Nome?.split(" ")[0]}`}
      />
      {/* </a> */}
    </HeaderWrapper>
  );
}

export default Header;
